var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('toolbar',[_c('h2',[_c('i',{staticClass:"fa fa-clipboard-check"}),_vm._v("\n\t\t\tForms\n\t\t")]),_c('div',{staticClass:"controls"},[_vm._t("default"),_c('nav-tabs',{attrs:{"mobile-breakpoint":1024,"tabs":[
					{
						label: 'Templates',
						path: '/forms/templates',
						icon: 'fa-clipboard-check'
					},
					{
						label: 'List',
						path: '/forms/list',
						icon: 'fa-list'
					},
					{
						label: 'Marketplace',
						path: '/forms/marketplace',
						icon: 'fa-store'
					}
				]}})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }